// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_0bc5e8de02--wrapper--jL4mV","tooltip":"_0bc5e8de02--tooltip--GMLwT","item":"_0bc5e8de02--item--n0Fi9"};